import React, { useState, useEffect, useRef } from 'react'
import { Card, Tabs } from 'antd'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'
import moment from 'moment'
import { paginationInit, formatMessageNew, downLoadFileBlob } from '@/utils/common'
import { searchByEpc, searchByUpc, exportReport } from '../../../services/rfid/greyMarket/greyMarket'
import AntdTable from '@/components/table/AntdTable'
import SearchBar from '@/components/searchbar/SearchBar'
import ActionBar from '@/components/table/ActionBar'

const dateFormat = 'YYYY-MM-DD HH:mm'
const startMonth = dayjs().startOf('day')
const endMonth = dayjs().endOf('day')

const GreyMarketReport = () => {
  let partUserInfo = useSelector(state => state.commonStore.partUserInfo)

  const [epcTableList, setEpcTableList] = useState([])
  const [upcTableList, setUpcTableList] = useState([])
  const [epcQueryFlag, setEpcQueryFlag] = useState(false)
  const [upcQueryFlag, setUpcQueryFlag] = useState(false)
  const [epcPagination, setEpcPagination] = useState(paginationInit)
  const [upcPagination, setUpcPagination] = useState(paginationInit)
  // const [hideValues, setHideValues] = useState([])
  const mounting = useRef(false)
  let formRef = useRef(null)
  let searchListInit = [
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.epc',
      key: 'epc',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.upc',
      key: 'upc',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.style',
      key: 'style',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.shipTo',
      key: 'shipTo',
      initialValues: '',
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.greyMarketLocale.obScanTimeForReport',
      key: 'obScanTime',
      format: dateFormat,
      showTime: true,
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'timeRange',
      label: 'languageObj.greyMarketLocale.gmScanTime',
      key: 'gmScanTime',
      showTime: true,
      format: dateFormat,
      initialValues: [startMonth, endMonth],
      isdefaultfilter: 'true',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.qrCode',
      key: 'qrCode',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.markFor',
      key: 'markFor',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.soldTo',
      key: 'soldTo',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    },
    {
      type: 'input',
      label: 'languageObj.greyMarketLocale.operator',
      key: 'operator',
      initialValues: '',
      spans: {
        xl: 8,
        xxl: 8
      }
    }
  ]

  const epcTableColumns1 = [
    {
      title: formatMessageNew('languageObj.greyMarketLocale.epc'),
      dataIndex: 'epc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.globalQrCode'),
      dataIndex: 'qrCode',
      width: 120,
      render: (text, record) => {
        if (record.actualType === 1) {
          return (
            <div className="word_break_all" style={{ color: 'green' }}>
              {text}
            </div>
          )
        } else {
          return <div className="word_break_all">{text}</div>
        }
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.localQrCode'),
      dataIndex: 'localQrCode',
      width: 120,
      render: (text, record) => {
        if (record.actualType === 2) {
          return (
            <div className="word_break_all" style={{ color: 'green' }}>
              {text}
            </div>
          )
        } else {
          return <div className="word_break_all">{text}</div>
        }
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.style'),
      dataIndex: 'productCode',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.size'),
      dataIndex: 'size',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.markFor'),
      dataIndex: 'markFor',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.soldTo'),
      dataIndex: 'soldTo',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.shipTo'),
      dataIndex: 'shipTo',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const epcTableColumns2 = [
    {
      title: formatMessageNew('languageObj.commonLocale.shipToName'),
      dataIndex: 'shipToName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const epcTableColumns3 = [
    {
      title: formatMessageNew('languageObj.greyMarketLocale.obScanTimeForReport'),
      dataIndex: 'obScanTime',
      width: 120,
      render: (text, record) => {
        return (
          record.shipToType === 1 && <div className="word_break_all">{text && moment(text).format(dateFormat)}</div>
        )
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.gmScanTime'),
      dataIndex: 'updateTime',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text && moment(text).format(dateFormat)}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.operator'),
      dataIndex: 'operateUser',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const upcTableColumns1 = [
    {
      title: formatMessageNew('languageObj.greyMarketLocale.upc'),
      dataIndex: 'upc',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.style'),
      dataIndex: 'style',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.size'),
      dataIndex: 'size',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.markFor'),
      dataIndex: 'markFor',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.soldTo'),
      dataIndex: 'soldTo',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    },
    {
      title: formatMessageNew('languageObj.greyMarketLocale.shipTo'),
      dataIndex: 'shipTo',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const upcTableColumns2 = [
    {
      title: formatMessageNew('languageObj.commonLocale.shipToName'),
      dataIndex: 'shipToName',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]
  const upcTableColumns3 = [
    {
      title: formatMessageNew('languageObj.greyMarketLocale.qty'),
      dataIndex: 'qty',
      width: 120,
      render: text => {
        return <div className="word_break_all">{text}</div>
      }
    }
  ]

  useEffect(() => {
    if (mounting.current) searchEpcData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [epcQueryFlag])

  useEffect(() => {
    if (mounting.current) searchUpcData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [upcQueryFlag])

  const searchDataBtn = () => {
    mounting.current = true
    const epcPg = { ...epcPagination, currentPage: 1 }
    setEpcPagination(epcPg)
    setEpcQueryFlag(!epcQueryFlag)
    const upcPg = { ...upcPagination, currentPage: 1 }
    setUpcPagination(upcPg)
    setUpcQueryFlag(!upcQueryFlag)
  }

  const getParam = () => {
    const info = (formRef.current && formRef.current.getSearchValue()) || {}
    const { obScanTime, gmScanTime } = info
    let obScanStart = obScanTime && obScanTime[0] ? obScanTime[0].format(dateFormat) : null
    let obScanEnd = obScanTime && obScanTime[1] ? obScanTime[1].format(dateFormat) : null
    let gmScanStart = gmScanTime && gmScanTime[0] ? gmScanTime[0].format(dateFormat) : null
    let gmScanEnd = gmScanTime && gmScanTime[1] ? gmScanTime[1].format(dateFormat) : null
    const param = {
      epc: info.epc,
      upc: info.upc,
      shipTo: info.shipTo,
      qrCode: info.qrCode,
      markFor: info.markFor,
      style: info.style,
      size: info.size,
      soldTo: info.soldTo,
      operator: info.operator,
      obScanStart,
      obScanEnd,
      gmScanStart,
      gmScanEnd
    }
    return param
  }

  const searchEpcData = () => {
    const param = getParam()
    const epcParams = { param, current: epcPagination.currentPage, size: epcPagination.pageSize }
    searchByEpc(epcParams).then(res => {
      const dt = res.resultData
      const epcPg = { ...epcPagination, total: dt.total }
      setEpcTableList(dt.records)
      setEpcPagination(epcPg)
    })
  }

  const searchUpcData = () => {
    const param = getParam()
    const upcParams = { param, current: upcPagination.currentPage, size: upcPagination.pageSize }
    searchByUpc(upcParams).then(res => {
      const dt = res.resultData
      const upcPg = { ...upcPagination, total: dt.total }
      setUpcTableList(dt.records)
      setUpcPagination(upcPg)
    })
  }

  const searchClearDataBtn = () => {
    searchDataBtn()
  }

  const handleEpcTableChange = pagina => {
    const params = {
      ...epcPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setEpcPagination({ ...params })
    setEpcQueryFlag(!epcQueryFlag)
  }

  const handleUpcTableChange = pagina => {
    const params = {
      ...upcPagination,
      currentPage: pagina.current,
      pageSize: pagina.pageSize
    }
    setUpcPagination({ ...params })
    setUpcQueryFlag(!upcQueryFlag)
  }

  const downLoadFun = () => {
    const param = getParam()
    exportReport(param).then(res => {
      downLoadFileBlob(res)
    })
  }
  let epcTableColumns = epcTableColumns1
  let upcTableColumns = upcTableColumns1
  if (partUserInfo.greyMarketAccess === 1) {
    epcTableColumns = epcTableColumns.concat(epcTableColumns2)
    upcTableColumns = upcTableColumns.concat(upcTableColumns2)
  }
  epcTableColumns = epcTableColumns.concat(epcTableColumns3)
  upcTableColumns = upcTableColumns.concat(upcTableColumns3)
  const tabItems = [
    {
      key: 'epc',
      label: 'By EPC',
      children: (
        <div>
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end' }} />
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={epcTableList}
            columns={epcTableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_greyMarketEpcColumns_2"
            iconTop={20}
            pagination={epcPagination}
            onChange={handleEpcTableChange}
            scroll={{
              x: 2300
            }}
          />
        </div>
      )
    },
    {
      key: 'upc',
      label: 'By UPC',
      children: (
        <div>
          <ActionBar onDownload={downLoadFun} style={{ alignItems: 'end' }} />
          <AntdTable
            rowKey={(record, index) => record.id || index}
            dataSource={upcTableList}
            columns={upcTableColumns}
            // 独一无二的标识，不能重复
            columnsKey="columns_greyMarketUpcColumns_2"
            iconTop={20}
            pagination={upcPagination}
            onChange={handleUpcTableChange}
            scroll={{
              x: 2300
            }}
          />
        </div>
      )
    }
  ]

  return (
    <div>
      <Card bordered={false} bodyStyle={{ padding: 4 }}>
        <div className="search-bar">
          <SearchBar
            ref={formRef}
            searchList={searchListInit}
            showCollapseBtn={true}
            showSearchBtn={true}
            showClearBtn={true}
            onSearch={searchDataBtn}
            onClear={searchClearDataBtn}
          />
          {/* <Col
              xs={24}
              sm={12}
              md={12}
              lg={8}
              xl={8}
              xxl={8}
              className="right_search"
              style={{ justifyContent: 'flex-end' }}
            >
              {filterIsExpend ? (
                <Button type="link" onClick={onCollapseFilter}>
                  {formatMessageNew('languageObj.greyMarketLocale.collapse')} <UpOutlined />
                </Button>
              ) : (
                <Button type="link" onClick={onExpandFilter}>
                  {formatMessageNew('languageObj.greyMarketLocale.expand')} <DownOutlined />
                </Button>
              )}
              <Button icon={<SearchOutlined />} type="primary" onClick={searchDataBtn}>
                {formatMessageNew('languageObj.commonLocale.search')}
              </Button>
              <Button onClick={searchClearDataBtn}>{formatMessageNew('languageObj.commonLocale.clear')}</Button>
          
            </Col>
          </SearchBar> */}
        </div>
        <div className="content-container">
          {/* <div className="opt_btn mb15" style={{ display: 'flex' }}>
            <Button type="primary" onClick={downLoadFun}>
              {formatMessageNew('languageObj.commonLocale.download')}
            </Button>
          </div> */}
          <Tabs items={tabItems} defaultActiveKey="epc" />
        </div>
      </Card>
    </div>
  )
}
export default GreyMarketReport
